import { createActionCreator, createReducer } from 'deox';
import { Workspace, WorkspaceState } from 'types/Clipboard';
import { AppState } from 'types/AppState';

const defaultState: WorkspaceState = {
  current: Workspace.Artboard
};

export const setCurrentWorkspace = createActionCreator(
  'WORKSPACE/SET_CURRENT',
  resolve => (workspace: Workspace) => resolve(workspace)
);

export const workspace = createReducer(defaultState, handle => [
  handle(setCurrentWorkspace, (state, { payload }) => ({ ...state, current: payload }))
]);

export const getCurrentWorkspace = (state: AppState): Workspace => state.workspace.current;
